/**
 * Lotus Mega Menu — assets/mega-menu.js
 * Premium Jewellery Shopify Dawn Theme
 * No jQuery. Vanilla ES6+.
 * Version: 1.0.2 — Fixed: cart count not updating on Add to Cart (native/global fetch sync)
 */

'use strict';

(function () {
  /* ─── Constants ────────────────────────────────────────── */
  const HOVER_OPEN_DELAY = 80;    // ms before panel opens on hover
  const HOVER_CLOSE_DELAY = 200;  // ms before panel closes after cursor leaves
  const ATC_SUCCESS_DURATION = 2000; // ms to show "Added" state
  const MOBILE_BREAKPOINT = 1024;

  /* ─── State ─────────────────────────────────────────────── */
  let activeItem = null;
  let openTimer = null;
  let closeTimer = null;
  let isTouch = false;
  let cartSyncInitialized = false;

  /* ─── Utility ───────────────────────────────────────────── */
  function detectTouch() {
    isTouch = window.matchMedia('(pointer: coarse)').matches;
  }

  function clearTimers() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
  }

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function trapFocus(panel, firstEl, lastEl) {
    panel.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    });
  }

  /* ─── Desktop Mega Menu ─────────────────────────────────── */
  function openPanel(item) {
    if (activeItem && activeItem !== item) {
      closePanel(activeItem, true);
    }
    activeItem = item;
    item.classList.add('is-open');
    const trigger = item.querySelector('[data-mega-menu-trigger]');
    const panel = item.querySelector('[data-mega-panel]');
    if (!trigger || !panel) return;
    trigger.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');
    panel.setAttribute('aria-hidden', 'false');
  }

  function closePanel(item, immediate) {
    if (!item) return;
    item.classList.remove('is-open');
    const trigger = item.querySelector('[data-mega-menu-trigger]');
    const panel = item.querySelector('[data-mega-panel]');
    if (!trigger || !panel) return;
    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    if (immediate) {
      panel.setAttribute('hidden', '');
    } else {
      // Wait for CSS transition to complete
      const duration = parseFloat(
        getComputedStyle(panel).transitionDuration
      ) * 1000 || 320;
      setTimeout(() => {
        if (!item.classList.contains('is-open')) {
          panel.setAttribute('hidden', '');
        }
      }, duration);
    }
    if (activeItem === item) activeItem = null;
  }

  function closeAll() {
    document.querySelectorAll('.mega-menu-nav__item.is-open').forEach(item => {
      closePanel(item, false);
    });
  }

  function initDesktopHover() {
    const items = document.querySelectorAll('.mega-menu-nav__item.has-mega-menu');

    items.forEach(item => {
      /* ── Hover open ── */
      item.addEventListener('mouseenter', () => {
        if (isMobile() || isTouch) return;
        clearTimers();
        openTimer = setTimeout(() => openPanel(item), HOVER_OPEN_DELAY);
      });

      /* ── Hover leave ── */
      item.addEventListener('mouseleave', () => {
        if (isMobile() || isTouch) return;
        clearTimers();
        closeTimer = setTimeout(() => closePanel(item, false), HOVER_CLOSE_DELAY);
      });

      /* ── Click fallback (touch/keyboard) ── */
      const trigger = item.querySelector('[data-mega-menu-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', (e) => {
        if (!isMobile() && !isTouch) {
          // On desktop non-touch, allow link navigation
          return;
        }
        e.preventDefault();
        if (item.classList.contains('is-open')) {
          closePanel(item, false);
        } else {
          openPanel(item);
        }
      });

      /* ── Keyboard ── */
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (item.classList.contains('is-open')) {
            closePanel(item, false);
            trigger.focus();
          } else {
            openPanel(item);
            // Focus first focusable inside panel
            const panel = item.querySelector('[data-mega-panel]');
            if (panel) {
              const firstFocusable = panel.querySelector(
                'a, button, [tabindex="0"]'
              );
              if (firstFocusable) {
                setTimeout(() => firstFocusable.focus(), 20);
              }
            }
          }
        }

        if (e.key === 'Escape') {
          closePanel(item, false);
          trigger.focus();
        }
      });

      /* ── Escape from inside panel ── */
      const panel = item.querySelector('[data-mega-panel]');
      if (panel) {
        panel.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            closePanel(item, false);
            trigger.focus();
          }
        });
      }
    });

    /* ── Close when clicking outside ── */
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.mega-menu-nav__item.has-mega-menu')) {
        closeAll();
      }
    });

    /* ── Close on focus outside ── */
    document.addEventListener('focusin', (e) => {
      if (activeItem && !activeItem.contains(e.target)) {
        closePanel(activeItem, false);
      }
    });
  }

  /* ─── Mobile Drawer ─────────────────────────────────────── */
  function initMobileDrawer() {
    const toggle = document.querySelector('[data-mobile-toggle]');
    const drawer = document.querySelector('[data-mobile-drawer]');
    const overlay = document.querySelector('[data-mobile-overlay]');
    const closeBtn = document.querySelector('[data-mobile-close]');
    if (!toggle || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      // Focus first focusable inside
      const first = drawer.querySelector('button, a, [tabindex="0"]');
      if (first) setTimeout(() => first.focus(), 60);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    }

    toggle.addEventListener('click', () => {
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  /* ─── Mobile Accordion ──────────────────────────────────── */
  function initMobileAccordions() {
    const triggers = document.querySelectorAll(
      '.mega-menu-mobile-nav__accordion-trigger'
    );

    triggers.forEach(trigger => {
      const panelId = trigger.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (!panel) return;

      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        // Close all others
        triggers.forEach(t => {
          if (t !== trigger) {
            t.setAttribute('aria-expanded', 'false');
            const p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.setAttribute('hidden', '');
          }
        });

        // Toggle this
        if (isExpanded) {
          trigger.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', '');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('hidden');
        }
      });
    });
  }

  /* ─── Add to Cart (custom buttons with data-atc-button) ─── */
  function initAddToCart() {
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-atc-button]');
      if (!btn) return;
      e.preventDefault();

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      // Already loading
      if (btn.classList.contains('is-loading')) return;

      setAtcState(btn, 'loading');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (!response.ok) {
          const err = await response.json();
          throw new Error(err.description || 'Could not add to cart');
        }

        setAtcState(btn, 'success');

        // Update cart count bubble (Dawn theme)
        refreshCartCount();

        // Dispatch event for other scripts / drawer
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        setTimeout(() => setAtcState(btn, 'idle'), ATC_SUCCESS_DURATION);

      } catch (error) {
        console.error('[MegaMenu] Add to cart error:', error);
        setAtcState(btn, 'idle');
        btn.title = error.message || 'Could not add to cart. Please try again.';
      }
    });
  }

  function setAtcState(btn, state) {
    btn.classList.remove('is-loading', 'is-success');
    btn.disabled = false;

    if (state === 'loading') {
      btn.classList.add('is-loading');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    } else if (state === 'success') {
      btn.classList.add('is-success');
      btn.setAttribute('aria-busy', 'false');
      btn.setAttribute('aria-label', btn.getAttribute('aria-label').replace('Add', 'Added'));
    } else {
      btn.setAttribute('aria-busy', 'false');
    }
  }

  /* ─── Global Cart Sync ───────────────────────────────────
     Catches ANY add-to-cart call — Dawn's native product-form
     submit, quick-add modals, third-party apps, or our own
     [data-atc-button] — by intercepting fetch() calls that hit
     /cart/add or /cart/add.js, and refreshing the header cart
     bubble whenever one succeeds. This fixes cases where the
     bubble never updates because the add-to-cart button doesn't
     carry data-atc-button / data-variant-id.
  ───────────────────────────────────────────────────────── */
  function initCartSync() {
    if (cartSyncInitialized) return; // avoid double-patching fetch
    cartSyncInitialized = true;

    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      return originalFetch.apply(this, args).then((response) => {
        try {
          const input = args[0];
          const url = typeof input === 'string'
            ? input
            : (input && input.url) || '';

          if (response && response.ok && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
            refreshCartCount();
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          }
        } catch (err) {
          // Never let sync logic break the original fetch chain
          console.error('[MegaMenu] Cart sync error:', err);
        }
        return response;
      });
    };

    // Also catch Dawn's native cart-notification / cart-drawer refresh events,
    // and any classic (non-AJAX) form submit to /cart/add as a fallback.
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (form && form.action && /\/cart\/add(\?|$)/.test(form.action)) {
        // Give Shopify a moment to process before reading /cart.js
        setTimeout(refreshCartCount, 400);
      }
    });
  }

  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const count = cart.item_count;

      // Dawn theme + custom header cart count selectors
      const selectors = [
        '.cart-count-bubble',
        '[data-cart-count]',
        '#cart-icon-bubble .cart-count-bubble',
        '.header__icon--cart .cart-count-bubble',
      ];

      selectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          // Inner span inside Dawn's cart bubble
          const inner = el.querySelector('[aria-hidden]');
          if (inner) {
            inner.textContent = count;
          } else {
            el.textContent = count;
          }
          el.classList.toggle('hidden', count === 0);
        });
      });
    } catch (e) {
      // Silently fail — not critical
    }
  }

  /* ─── Close on Scroll ───────────────────────────────────── */
  function initScrollClose() {
    let scrollTimer;
    window.addEventListener('scroll', () => {
      if (!activeItem) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        closeAll();
      }, 50);
    }, { passive: true });
  }

  /* ─── Resize Handler ────────────────────────────────────── */
  function initResizeHandler() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        detectTouch();
        if (!isMobile()) {
          // Close mobile drawer if open when resizing to desktop
          const drawer = document.querySelector('[data-mobile-drawer]');
          if (drawer && drawer.classList.contains('is-open')) {
            drawer.classList.remove('is-open');
            drawer.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
        } else {
          // Close any open desktop panels
          closeAll();
        }
      }, 150);
    });
  }

  /* ─── Lazy Image Observe ────────────────────────────────── */
  function initLazyImages() {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });

    document.querySelectorAll('.mega-menu-panel img[data-src]').forEach(img => {
      observer.observe(img);
    });
  }

  /* ─── Theme Customizer Live Updates ─────────────────────── */
  function initCustomizerSupport() {
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        init();
      });
      document.addEventListener('shopify:section:reorder', () => {
        closeAll();
      });
    }
  }

  /* ─── ARIA Role Setup ───────────────────────────────────── */
  function initAria() {
    // Ensure all panels start hidden
    document.querySelectorAll('[data-mega-panel]').forEach(panel => {
      panel.setAttribute('aria-hidden', 'true');
      if (!panel.hasAttribute('hidden')) {
        panel.setAttribute('hidden', '');
      }
    });

    // Mark mobile drawer
    const drawer = document.querySelector('[data-mobile-drawer]');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
    }
  }

  /* ─── Init ──────────────────────────────────────────────── */
  function init() {
    detectTouch();
    initAria();
    initDesktopHover();
    initMobileDrawer();
    initMobileAccordions();
    initAddToCart();
    initCartSync();
    initResizeHandler();
    initScrollClose();
    initLazyImages();
    initCustomizerSupport();
  }

  /* ─── Boot ──────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();